import { Component, inject, input } from '@angular/core';
import { SystemNotificationsStore } from './system-notifications.store';
import { SystemNotificationBannerComponent } from './system-notification-banner.component';

@Component({
  selector: 'topo-system-notifications',
  imports: [SystemNotificationBannerComponent],
  providers: [SystemNotificationsStore],
  templateUrl: './system-notifications.component.html',
  styleUrl: './system-notifications.component.scss'
})
export class SystemNotificationsComponent {
  protected state = inject(SystemNotificationsStore);
  isSideNavVisible = input.required<boolean>();
  isSideNavExpanded = input.required<boolean>();
}
